import { ModalShowHide } from '../components/modal';

class SizePanel {
    #mobileSizeModal;
    Types = {
        ADDTOCART: 'add_to_cart',
        ADDTOCART_BUNDLE: 'add_to_cart_bundle',
        PERSONALIZE: 'personalize',
        WISHILIST: 'wishlist',
        SMARTGIFT: 'smartgift'
    }

    init (idName = '#size-panel-mobile') {
        this.idName = idName
        this.#onPanelOpenerClick();
        this.#onNotifyMeSizeClicked();
        this.#onCloseSizeModalMobile();
        this.#mobileSizeModal = new ModalShowHide(this.idName);
        this.#mobileSizeModal.hide();
    }

    openSizePanel (operation) {
        if (Foundation.MediaQuery.atLeast('large')) {
            $('.js-page-size-box').addClass('cc-sizeBox-isOpen');
        } else {
            this.#mobileSizeModal.show();
        }
        $(this.idName).data('operation', operation);
        if (operation === this.Types.ADDTOCART_BUNDLE) {
            let $sizeElements = $("[data-attr='size'] input,[data-attr='size-mobile'] input");
            let bundleQuantity = $('.js-add-to-cart-multipack').data('bundle-quantity');
            $sizeElements.each(function (element){
                if(parseInt($(this).attr('data-allocation'), 10) < parseInt(bundleQuantity, 10)) {
                    $(this).closest('label').addClass('cc-no-bundle');
                }
            })
        } else {
            $('.cc-no-bundle').removeClass('cc-no-bundle');
        }
        if(operation === this.Types.WISHILIST) {
            $('.notifyMe,.wishlistOnly').addClass('select-size-for-wishlist');
        } else {
            $('.notifyMe,.wishlistOnly').removeClass('select-size-for-wishlist');
        }
    }

    #closeSizePanel () {
        if (Foundation.MediaQuery.atLeast('large')) {
            $('.pdp-size-box').removeClass('cc-sizeBox-isOpen');
        } else {
            this.#mobileSizeModal.hide();
        }
        $('.pdp-size-box .js-sizeBox-openPanel').removeClass('cc-sizeBox-openPanel_error');
        $('#newsletter-error-msg').hide();
        $(this.idName).data('operation', '');
        $('.notifyMe,.wishlistOnly').removeClass('select-size-for-wishlist');
        $('.cc-no-bundle').removeClass('cc-no-bundle');
    }

    #onPanelOpenerClick () {
        $('.pdp-size-box .js-sizeBox-openPanel').on('click', e => {
            if ($('.pdp-size-box').hasClass('cc-sizeBox-isOpen')) {
                this.#closeSizePanel();
            } else {
                this.openSizePanel();
            }
        });
        $('.js-pdpStickyBar-size-openPanel').on('click', e => {
            if ($('.js-pdpStickyBar-select').hasClass('cc-sizeBox-isOpen')) {
                $('.js-pdpStickyBar-select').removeClass('cc-sizeBox-isOpen');
            } else {
                $('.js-pdpStickyBar-select').addClass('cc-sizeBox-isOpen');
            }
        });
    }

    afterSizeSelection (data, type) {
        let operation = $(this.idName).data('operation');
        this.#closeSizePanel();
        let stopSpinner = true;
        let selectedSize = $('[data-attr="size"] input:checked');
        if (!selectedSize.length) {
            $('.pdp-size-box').removeClass('size-selected');
            return stopSpinner;
        } else {
            $('#newsletter-error-msg').hide();
        }
        if (type !== 'size') {
            return stopSpinner;
        }
        let sizeDisplayValue = selectedSize.closest('label').find('.js-size-button__span').text();
        $('.pdp-size-box .js-sizeBox-openPanel').attr('aria-invalid', 'false');
        $('.pdp-size-box .selected-size-value').text(sizeDisplayValue);
        $('.pdp-size-box').addClass('size-selected');
        if ($('.js-add-to-cart-multipack').length > 0) {
            let bundleQuantity = $('.js-add-to-cart-multipack').data('bundle-quantity');
            if(parseInt($(selectedSize).attr('data-allocation'), 10) < parseInt(bundleQuantity, 10)) {
                $('.js-add-to-cart-multipack').attr('disabled', true);
            } else {
                $('.js-add-to-cart-multipack').removeAttr('disabled');
            }
        }

        stopSpinner = false;
        switch (operation) {
            case this.Types.ADDTOCART:
                $('#add-to-cart-cta-pdp').trigger('click');
                break;
            case this.Types.ADDTOCART_BUNDLE:
                $('#add-to-cart-multipack-cta-pdp').trigger('click');
                break;
            case this.Types.PERSONALIZE:
                $('#personalizeButton .persButt').trigger('click');
                break
            case this.Types.WISHILIST:
                $('body').trigger('wishlist:add-pid', {pid: data.product.id});
                break;
            case this.Types.SMARTGIFT:
                $('.add-to-cart-actions .js-smart-gift').trigger('click');
                $('#smartgiftButton').trigger('click');
                break;
            default:
                stopSpinner = true;
        }
        return stopSpinner;
    }

    #onNotifyMeSizeClicked () {
        const _self = this;
        $('.notifyMe,.wishlistOnly').on('click', (e) => {
            if (!$(e.currentTarget).hasClass('select-size-for-wishlist')) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            $.spinner().start();
            const infoURL = $(e.currentTarget).closest('label').find('input').data('url');
            $.ajax({
                url: infoURL,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    if (data.product.readyToOrder) {
                        if ($(e.currentTarget).hasClass('wishlistOnly')) {
                            let sizeDisplayValue = $(e.currentTarget).closest('label').find('.size-list-item-display-value').text();
                            $('.pdp-size-box .selected-size-value').text(sizeDisplayValue);
                            $('.pdp-size-box').addClass('size-selected');
                        }
                        const pid = encodeURIComponent(data.product.id)
                        $('body').trigger('wishlist:add-pid', {pid: pid});
                    } else {
                        $.spinner().stop();
                        _self.#closeSizePanel();
                    }
                },
                error: function () {
                    $.spinner().stop();
                    _self.#closeSizePanel();
                }
            });
        });

        $('body').on('wishlist:update', () => {
            $.spinner().stop();
            _self.#closeSizePanel();
        });
    }

    #onCloseSizeModalMobile () {
        const _self = this;
        $('body').on('click', '.size-selector-mobile-modal', () => {
            _self.#closeSizePanel();
        });
    }
}

const sizePanel = new SizePanel();
export default sizePanel;
